import logo200Image from '../assets/img/logo/logo_2.png';
import React from 'react';
import {
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Col,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';
import Typography from '../components/Typography';
import axios from 'axios';
import { MdCameraAlt, MdFace, MdDone, MdClear } from 'react-icons/md';
import Avatar from '../components/Avatar';
import userPlaceholder from '../assets/img/users/profile.jpg';
import StorageService from '../services/StorageService';
import NotificationSystem from 'react-notification-system';
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants';
import { getTax } from '../utils/dropdownlist';
import update from 'immutability-helper';
import Select from 'react-select';

class PosProductForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isEdit: false,
      isGlobal: '',
      productList: [],
      product_id: '',
      qty_data: [{ unit: '', qty: 0 }],
    };
  }

  componentDidMount() {
    getTax.call(this);
    if (this.props.data.isGlobal) {
      if (this.props.data.isEdit) {
        // let id = this.props.data.selectedId;
        // const data = this.props.data.taxList.find(e => e.id === id);
        // this.setState({
        //   id: id,
        //   tax_code: data.tax_code,
        //   name: data.name,
        //   company_id: data.company_id,
        //   rate: data.rate,
        //   reg_no: data.reg_no,
        //   inclusive: data.inclusive,
        //   options: data.options,
        //   isEdit: true,
        // });
      }
    } else {
      this.setState({
        store_id: this.props.data.store_id,
        isGlobal: this.props.data.isGlobal,
      });
      this.getProductList();
    }
  }

  //   changeHandler = event => {
  //     this.setState({
  //       [event.target.name]: event.target.value,
  //     });
  //   };

  qtyChangeHandler = event => {
    const { name, value } = event.target;
    // let qty = [...this.state.qty_data];
    // qty[0][name] = value;

    this.setState({
      //qty_data: qty,
      qty_data: update(this.state.qty_data, { 0: { [name]: { $set: value } } }),
    });
  };

  productChangeHandler = event => {
    const { label, value } = event;
    const type = this.state.productList.find(x => x.id == value);
    this.setState({
      product_id: value,
      qty_data: update(this.state.qty_data, {
        0: { unit: { $set: type.product_type } },
      }),
    });
  };

  handleSubmit = event => {
    event.preventDefault();
    const user = StorageService.getSession('user_info');
    const comp = StorageService.getSession('selected_org');
    const url = process.env.REACT_APP_UNITY_API2_URL;
    if (this.state.isGlobal) {
      //   if (!this.state.isEdit) {
      //     this.editTax(user, url);
      //   } else {
      //     this.createTax(user, url);
      //   }
    } else {
      this.addStoreProduct(user, comp, url);
    }
  };

  getProductList() {
    const user = StorageService.getSession('user_info');
    const comp = StorageService.getSession('selected_org');
    const url = process.env.REACT_APP_UNITY_API2_URL;
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
    };

    axios
      .post(url + ':3002/v1/product', data)
      .then(response => {
        const result = response.data;
        const storeProduct = this.props.data.productList;
        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }
        let ProductOp = result.data.filter(
          x => !storeProduct.some(y => y.id === x.id),
        );
        this.setState({
          productList: ProductOp,
          store_id: this.props.data.store_id,
          isGlobal: this.props.data.isGlobal,
        });
      })
      .catch(error => {
        alert(error);
      });
  }

  addStoreProduct(user, comp, url) {
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.state.store_id,
      company_id: comp.CompanyID,
      product_id: this.state.product_id,
      qty_data: JSON.stringify(this.state.qty_data),
      added_by: user.email,
    };
    axios
      .post(url + ':3002/v1/product/store/add', data)
      .then(response => {
        const result = response.data;
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false);
          return;
        }

        this.props.closeModal(
          <MdDone />,
          'Product added successfully.',
          'success', //'error' post when return error
          false,
        );
      })
      .catch(error => {
        if (error.response) {
          alert(error.response.data.message);
        } else {
          alert('Error', error.message);
        }
      });
  }

  render() {
    // let options = [
    //   { value: 'chocolate', label: 'Chocolate' },
    //   { value: 'strawberry', label: 'Strawberry' },
    //   { value: 'vanilla', label: 'Vanilla' },
    // ];

    let options = [
      ...this.state.productList
        .reduce((r, o) => {
          let key = o.id;
          let item = { value: o.id, label: o.product_no + ' ' + o.name };
          return r.set(key, item);
        }, new Map())
        .values(),
    ];

    return (
      <Form className="AuthForm" onSubmit={this.handleSubmit}>
        <ModalHeader toggle={this.props.onToggleModal()}>
          Product {this.state.isGlobal ? 'Details' : 'List'}
        </ModalHeader>
        <ModalBody>
          {this.state.isGlobal ? (
            <Row></Row>
          ) : (
            <Row>
              <Col md={12}>
                <FormGroup>
                  <Label>Product</Label>
                  <Select
                    options={options}
                    name="product_id"
                    onChange={this.productChangeHandler}
                    required
                  />
                  {/* <Input
                    type="select"
                    name="product_id"
                    onChange={this.productChangeHandler}
                    required
                  >
                    <option></option>
                    {this.state.productList &&
                      this.state.productList.length > 0 &&
                      this.state.productList.map(item => {
                        return (
                          <option key={item.id} value={item.id}>
                            {item.name}
                          </option>
                        );
                      })}
                  </Input> */}
                </FormGroup>
                <FormGroup>
                  <Label>Quantity</Label>
                  <Input
                    type="text"
                    name="qty"
                    value={this.state.qty_data[0].qty}
                    onChange={this.qtyChangeHandler}
                  />
                </FormGroup>
              </Col>
            </Row>
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            className="theme-button theme-button-secondary"
            onClick={this.props.onToggleModal()}
          >
            Close
          </Button>
          <Button className="theme-button theme-button-primary" type="submit">
            Save
          </Button>
        </ModalFooter>
      </Form>
    );
  }
}

export const STATE_ADD = 'ADD';
export const STATE_EDIT = 'EDIT';
export default PosProductForm;
